import { CustomField, CustomFieldAnswer } from '../models';


export class CustomAnswerHelper {

    static fieldTitle(answer: CustomFieldAnswer, fields: CustomField[]): string {
        const field = fields.find(f => f.id === answer.custom_field);
        return field ? field.title : '';
    }

    static answerLabels(answer: CustomFieldAnswer, fields: CustomField[]): string {
        // Free-text answers show their value; checkbox answers map the selected
        // choice ids back to their titles via the loaded field definitions.
        if (answer.value) {
            return answer.value;
        }
        const field = fields.find(f => f.id === answer.custom_field);
        if (!field) {
            return '';
        }
        return answer.choices
            .map(id => {
                const choice = field.choices.find(c => c.id === id);
                return choice ? choice.title : null;
            })
            .filter(title => title !== null)
            .join(', ');
    }
}
